import { useFormatting } from "@msys/ui";
import type { GridColDef } from "@mui/x-data-grid-premium";
import React from "react";
import type { EstimatedCalculation__ItemFragment } from "../../doc-items/boxes/EstimatedCalculationBox.generated.js";
import type { DocDataGrid_ItemFragment } from "../DocDataGrid.generated.js";
import type { DocDataGridRow } from "../types.js";

function DurationTotalCell({ value }: { value: number }) {
  const { getFormattedDuration } = useFormatting();
  const formatted = `${getFormattedDuration(value)}h`;
  return (
    <span style={{ fontWeight: value > 0 ? "bold" : "normal" }}>
      {formatted}
    </span>
  );
}

interface Options {
  headerName: string;
}

export function createTimeTotalColumn<
  T extends DocDataGrid_ItemFragment & EstimatedCalculation__ItemFragment,
>(options: Options): GridColDef<DocDataGridRow<T>> {
  return {
    field: "timeTotal",
    headerName: options.headerName,
    width: 90,
    editable: false,
    sortable: false,
    filterable: false,
    valueGetter: (_value, row) => row.item?.proposedCalculation?.timeTotal ?? 0,
    renderCell: params => {
      if (params.row.kind === "input" || !params.row.item) return null;
      return <DurationTotalCell value={params.value ?? 0} />;
    },
  };
}
